import React, { useState, useEffect, useRef, useCallback } from "react"
import Flink from '~/components/shared/flink'
import { imgSize } from '~/utils/helpers'

import { IconChevLeft, IconChevRight } from '~/components/icons/chevrons'

import { aria_btn, cta_link } from "~/styles/app.module.scss"
import { arrowbtn } from "~/styles/pages/factory.module.scss"
import * as styles from "~/styles/stores/featured.module.scss"


const Featured = ({ title, stores }) => {

  const total = stores.length
  const [pos, setPos] = useState(0)
  const [backon, setBackon] = useState(false)
  const [forwon, setForwon] = useState(true)

  const wrapRef = useRef(null)
  const slideRef = useRef(null)

  const handleBack = () => {
    const inview = arrow_inview()
    let new_pos = inview[0] - 1 - inview.length
    if (new_pos < 0) new_pos = 0

    setPos(new_pos)
  }
  const handleForward = () => {
    const inview = arrow_inview()
    let new_pos 
    if (inview.length) {
      new_pos = inview[inview.length - 1] + 1
      if (new_pos + inview.length >= total) new_pos = total
      if (pos === total) new_pos = 0
    } else {
      new_pos = total
    }
    if (!slideRef.current) {
      const arr = Array.from(document.querySelectorAll(`.${styles.store}`))
      slideRef.current = arr[new_pos - 1]
    }

    setPos(new_pos)
  }

  const arrow_inview = () => {
    const wrap = wrapRef.current
    const wrap_rect = wrap.getBoundingClientRect()
    const arr = Array.from(document.querySelectorAll(`.${styles.store}`))

    let inview = []
    arr.forEach((x, index) => {
      const el = x.getBoundingClientRect()
      const el_left = el.left - wrap_rect.left 
      const el_right = el.left + el.width - wrap_rect.left - 20
      if (el_left >= 0 && el_right < wrap_rect.width) inview.push(index)
    })
    return inview
  }

  const deskChange = useCallback(() => {
    const arr = Array.from(document.querySelectorAll(`.${styles.store}`))
    if (arr.length < 1) return
    const wrap = wrapRef.current
    const wrap_rect = wrap.getBoundingClientRect()
    const curr_scroll = wrap.scrollLeft

    const next_ind = pos === arr.length ? arr.length - 1 : pos
    const next = arr[next_ind].getBoundingClientRect()
    const next_scroll = next.left + (curr_scroll - wrap_rect.left) - 10

    wrap.scrollTo({
      top: 0,
      left: next_scroll,
      behavior: 'smooth'
    });
  }, [pos])

  const checkScroll = () => {
    const wrap = wrapRef.current
    const max_scrll = Math.round(wrap.scrollWidth - wrap.getBoundingClientRect().width) - 1
    
    const new_back = wrap.scrollLeft >= 5
    if (new_back !== backon) setBackon(new_back)

    const new_forw = wrap.scrollLeft <= max_scrll
    if (new_forw !== forwon) setForwon(new_forw)
  }

  const checkFit = () => {
    if (!stores || stores.length > 4) return ''
    return styles.fill_space
  }

  useEffect(() => {
    deskChange()
    
  }, [pos, slideRef, deskChange])

  useEffect(() => {
    const el = wrapRef.current

    if ( el ) {
      el.addEventListener('scroll', checkScroll, { passive: true })
      return () => {
        el.removeEventListener('scroll', checkScroll)
      }
    }
  })
  
  // useEffect(() => {

  // }, [])

  
  return (
    <div className={styles.wrap}>
      <div className={styles.head}>
        <div className={styles.title}>
          {title}
        </div>
        {!checkFit() && (
          <div className={styles.head_btns}>
            <button 
              type="button"
              className={`${aria_btn} ${arrowbtn} ${styles.dsk_arrowbtn} ${backon ? '' : styles.off}`}
              aria-label="Scroll Back" 
              onClick={(e)=>{handleBack()}}
            >
              <IconChevLeft icon_classes="" />
            </button>
            <button 
              type="button"
              className={`${aria_btn} ${arrowbtn} ${styles.dsk_arrowbtn} ${styles.forw}`}
              aria-label="Scroll Forward" 
              onClick={(e)=>{handleForward()}}
            >
              <IconChevRight icon_classes="" />
            </button>
          </div>
        )}
      </div>
      <div className={[styles.groups_wrap, checkFit()].join(' ')} ref={wrapRef}>
        <div className={styles.groups}>
          {stores && stores.map( (item, index) =>
            <Flink 
              key={item.page} 
              href={`/pages/${item.page}`}
              className={`${aria_btn} ${styles.store}`} 
              ref={pos === index ? slideRef : undefined}
            > 
              {(item.image) && (
                <div className={styles.image}>
                  <img src={imgSize(item.image,800)} alt={`Buck Mason ${item.title}, ${item.region}`} />
                </div>
              )}
              <div className={styles.cont}>
                <div className={styles.reg_title}>
                  <div className={styles.region}>
                    {item.region}
                  </div>
                  <div className={styles.title}>{item.title}</div>
                </div>
                <div className={[styles.more, cta_link].join(' ')}>
                  See More
                </div>
              </div>
            </Flink>
          )}
        </div>
      </div>
      <button 
        type="button"
        className={`${aria_btn} ${arrowbtn} ${styles.mob_arrowbtn} ${backon ? '' : styles.off}`}
        aria-label="Scroll Back" 
        onClick={(e)=>{handleBack()}}
      >
        <IconChevLeft icon_classes="" />
      </button>
      <button 
        type="button"
        className={`${aria_btn} ${arrowbtn} ${styles.mob_arrowbtn} ${styles.forw}`}
        aria-label="Scroll Forward" 
        onClick={(e)=>{handleForward()}}
      >
        <IconChevRight icon_classes="" />
      </button>

    </div>
  )
}

export default Featured




